'use strict';

module.exports = function forget(key) {
  delete this.items[key];
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/forget.js
// module id = 1234
// module chunks = 2